import React, { useState, useEffect } from "react";
import { Table, Tooltip, Badge, Input } from "antd";
import moment from "moment";
import { textEllipsis } from "../../Shared/Utils/CommonUtils";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CONSTANTS } from "../../Environments/constants";
import {
  faTriangleExclamation,
  faSquare,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
const { Search } = Input;
export default function InboxListingTable(props) {
  const { dataValues } = props;
  const [data, setData] = useState()
  useEffect(() => {
    const temp = [];
    dataValues?.forEach((item, index) => {
      temp.push({ sl_no: index + 1, ...item })
    });
    setData(temp)
  }, []);
  const history = useHistory();
  const getBadgeStatus = (text, item) => {
    let days = moment().diff(moment(item.last_action_time), "days");
    let badge = "";
    if (item?.sla_breached) {
      badge = "breached";
    } else {
      if ((days > 2 && days <= 4)) {
        badge = "warning";
      } else if ((days > 4 && days <= 7)) {
        badge = "error";
      } else if ((days >= 0 && days <= 2)) {
        badge = "success";
      }
    }
    return badge;
  };
  const getRowClass = (record) => {
    const badge = getBadgeStatus(record.lodged_on, record);
    if (badge === "breached") {
      return "warningRow";
    }
    return "";
  };
  const tooltipContent = () => {
    return (
      <>
        <div className="rowStyle">
          <div>
            <FontAwesomeIcon icon={faSquare} className="iconGreen iconStyles" />
          </div>
          <div>{CONSTANTS.RECEIVED_2_DAYS}</div>
        </div>
        <div className="rowStyle">
          <div>
            <FontAwesomeIcon
              icon={faSquare}
              className="iconYellow iconStyles"
            />
          </div>
          <div>{CONSTANTS.RECEIVED_4_DAYS}</div>
        </div>
        <div className="rowStyle">
          <div>
            <FontAwesomeIcon icon={faSquare} className="iconRed iconStyles" />
          </div>
          <div>{CONSTANTS.RECEIVED_MORE_4_DAYS}</div>
        </div>
        <div className="rowStyle">
          <div>
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              className="iconRed iconStyles"
            />
          </div>
          <div>{CONSTANTS.SLA_BREACHED}</div>
        </div>
      </>
    );
  };
  const onSearchItem = (value, columnName) => {
    const temp = []
    if (value)
      data.forEach(item => {
        if (item[columnName].toString().toLowerCase().includes(value.toLowerCase())) {
          temp.push(item);
        }
        setData(temp);
      })
    else {
      dataValues?.forEach((item, index) => {
        temp.push({ sl_no: index + 1, ...item })
      });
      setData(temp)
    }
  }

  const columns = [
    {
      title: <>
        <div style={{ textAlign: "center" }}>Sl No.
          <div style={{ height: 30 }} />
        </div>
      </>,
      dataIndex: "sl_no",
      key: "sl_no",
      width: 70,
      render: (text, i) => <div style={{ textAlign: "center" }}>{text}</div>,
    },
    {
      title: <>
        <div>
          Complaint ID
        </div>
        <Search
          placeholder="Search"
          allowClear
          onSearch={(value) => { onSearchItem(value, "ticket_Id") }}
          style={{
            width: 100,
            borderRadius: 6,
          }}
        />
      </>,
      dataIndex: "ticket_Id",
      ellipsis: true,
      width: 120,
      key: "ticket_Id",
      render: (text, i) => {
        return (
          <a
            onClick={() => {
              props.getSelectedItem(i.ticket_Id);
              // history.push(`/complaint-details/${i.ticket_Id}`);
            }}
          >
            <Tooltip title={text}>{text}</Tooltip>
          </a>
        )
      },
    },
    {
      title: <>
        <div>
          Category
        </div>
        <Search
          placeholder="Search"
          allowClear
          onSearch={(value) => { onSearchItem(value, "category") }}
          style={{
            width: 150,
            borderRadius: 6,
          }}
        />
      </>,
      dataIndex: "category",
      ellipsis: true,
      width: 300,
      key: "category",
      render: (text, i) => (
        <div>
          <Tooltip title={text?.join(", ")}>
            {textEllipsis(text?.join(", "), 40)}
          </Tooltip>
        </div>
      ),
    },
    {
      title: <>
        <div>
          Description
        </div>
        <Search
          placeholder="Search"
          allowClear
          onSearch={(value) => { onSearchItem(value, "description") }}
          style={{
            width: 200,
            borderRadius: 6,
          }}
        />
      </>,
      dataIndex: "description",
      ellipsis: true,
      width: 400,
      key: "description",
      render: (text, i) => (
        <div>
          <Tooltip title={text?.toString()}>
            {textEllipsis(text?.toString(), 40)}
          </Tooltip>
        </div>
      ),
    },
    // {
    //     title: "ULB",
    //     dataIndex: "ulb",
    //     ellipsis: true,
    //     width: 120,
    //     key: "description",
    //     render: (text, i) => (
    //       <div>
    //         <Tooltip title={text?.toString()}>
    //           {textEllipsis(text?.toString(), 20)}
    //         </Tooltip>
    //       </div>
    //     ),
    //   },
    //   {
    //     title: "Assigned to",
    //     dataIndex: "assigned_to",
    //     ellipsis: true,
    //     width: 150,
    //     key: "description",
    //     render: (text, i) => (
    //       <div>
    //         <Tooltip title={text?.toString()}>
    //           {textEllipsis(text?.toString(), 20)}
    //         </Tooltip>
    //       </div>
    //     ),
    //   },
    {
      title: <>
        <div>
          Assigned by
        </div>
        <Search
          placeholder="Search"
          allowClear
          onSearch={(value) => { onSearchItem(value, "assigned_by") }}
          style={{
            width: 150,
            borderRadius: 6,
          }}
        />
      </>,
      dataIndex: "assigned_by",
      ellipsis: true,
      width: 200,
      key: "assigned_by",
      render: (text, i) => (
        <div>
          <Tooltip title={text?.toString()}>
            {textEllipsis(text?.toString(), 22)}
          </Tooltip>
        </div>
      ),
    },
    {
      title: <>
        <div>
          Name
        </div>
        <Search
          placeholder="Search"
          allowClear
          onSearch={(value) => { onSearchItem(value, "name") }}
          style={{
            width: 150,
            borderRadius: 6,
          }}
        />
      </>,
      dataIndex: "name",
      ellipsis: true,
      width: 200,
      key: "name",
      render: (text, i) => (
        <div>
          <Tooltip title={text?.toString()}>
            {textEllipsis(text?.toString(), 22)}
          </Tooltip>
        </div>
      ),
    },
    {
      title: <>
        <div>
          Received on
        </div>
        <Search
          placeholder="Search"
          allowClear
          onSearch={(value) => { onSearchItem(value, "received_on") }}
          style={{
            width: 150,
            borderRadius: 6,
          }}
        />
      </>,
      dataIndex: "received_on",
      ellipsis: true,
      width: 200,
      key: "received_on",
      render: (text, i) => (
        <div>
          <Tooltip title={text?.toString()}>
            {textEllipsis(text?.toString(), 22)}
          </Tooltip>
        </div>
      ),
    },
    {
      title: (
        <>
          <div>
            Lodged on
            <Tooltip title={tooltipContent()}>
              <ExclamationCircleOutlined className='infoCircle' />
            </Tooltip>
          </div>
          <Search
            placeholder="Search"
            allowClear
            onSearch={(value) => { onSearchItem(value, "lodged_on") }}
            style={{
              width: 150,
              borderRadius: 6,
            }}
          />
        </>

      ),
      dataIndex: "lodged_on",
      ellipsis: true,
      width: 200,
      key: "lodged_on",
      filterIcon: <FontAwesomeIcon icon={faTriangleExclamation} />,
      render: (text, i) => {
        // let hours = moment().diff(moment(text), 'hours');
        const badge = getBadgeStatus(text, i);
        return (
          <Tooltip title={text?.toString()}>
            {badge && badge != "breached" && <Badge status={badge} />}
            {badge && badge === "breached" && (
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className="triangle"
              />
            )}
            {textEllipsis(text?.toString(), 22)}
          </Tooltip>
        );
      },
    },
    // {
    //   title: "Reported by",
    //   dataIndex: "user_name",
    //   ellipsis: true,
    //   width: 120,
    //   key: "user_name",
    //   render: (text, i) => (
    //     <div>
    //       <Tooltip title={text?.toString()}>
    //         {textEllipsis(text?.toString(), 20)}
    //       </Tooltip>
    //     </div>
    //   ),
    // },
    {
      title: <>
        <div>
          Address
        </div>
        <Search
          placeholder="Search"
          allowClear
          onSearch={(value) => { onSearchItem(value, "address") }}
          style={{
            width: 200,
            borderRadius: 6,
          }}
        />
      </>,
      dataIndex: "address",
      ellipsis: true,
      width: 300,
      key: "address",
      render: (text, i) => (
        <div>
          <Tooltip title={text?.toString()}>
            {textEllipsis(text?.toString(), 35)}
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
        }}
      ></div>
      <Table
        rowClassName={(record) => getRowClass(record)}
        columns={columns}
        dataSource={data}
        size="small"
        scroll={{
          x: 1300,
        }}
      />
    </div>
  );
}
